import { render } from "./ElimdekiIslerView.vue?vue&type=template&id=bf30aee2"
import script from "./ElimdekiIslerView.vue?vue&type=script&lang=js"
export * from "./ElimdekiIslerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__